var _defs, _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFeatherlogowhite(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 261.09 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n    "))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M105.98,204.18c-18.98,7.08-38.07,12.74-57.08,17.02,33.47,37.73,81.13,55.33,133.44,29.01l.42-1.88c4.16-30.18,3.75-42.8,.75-62.45-3-19.65-36.63-116.66-56.45-149.81C112.85,12.3,64.73-10.65,23.29,5.29c-2.5,.97-4.57,2.81-5.8,5.19C-7.91,59.79-4.01,122.9,18.69,173.66c26.43,14.11,55.88,24.4,87.29,30.51h0Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.77,181.35l-16.97,8.14c31.45,65.55,99.01,88.85,134.09,96.73l13.2-16.54c-27.66-4.94-99.33-23.76-130.32-88.34Z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatherlogowhite);
export default __webpack_public_path__ + "static/media/feather logo white.18942e1e63859b20d663124ca419da68.svg";
export { ForwardRef as ReactComponent };